module.exports = __webpack_public_path__ + "img/bg-1.9128aca7.png";